import React from "react";

import { useSecondaryNav } from "@shared/hooks";

import ions from "@ions";
import { Context } from "@ions-interface";

import { returnStringIfTrue } from "@app/helpers/componentHelpers";
import { useDeviceType } from "@app/hooks/useDeviceType";

import { Inline } from "@fermions";

import { Icon } from "@atoms/Icon";

import Title from "@components/atoms/Title";

import "./PageHeader.scss";

export interface PageHeaderType {
  title?: string;
  hasTitleTooltip?: boolean;
  subtitle?: Node | string | null;
  subtitleActionIcon: Node | null;
  sticky?: boolean;
  icon?: string;
  actions?: Node | null;
  content?: Node | null;
  tagline?: string;
  context?: Context | null;
}

interface PageHeaderProps {
  header: PageHeaderType;
  classNames?: {
    banner: string;
  };
}

const PageHeader = ({ header, classNames }: PageHeaderProps) => {
  const { isMobile } = useDeviceType();
  const { toggleExpanded, isExpanded } = useSecondaryNav();
  const fallbackContext = ions.context?.default?.pageTitle;

  return (
    <>
      <div
        id={returnStringIfTrue(header.sticky, "page-template__sticky-heading")}
        data-html2canvas-ignore
        className={`${returnStringIfTrue(
          classNames?.banner,
          classNames?.banner
        )} page-template__body__content__heading${returnStringIfTrue(
          header.sticky,
          "--sticky"
        )} page-template__body__content__heading--context-${
          header.context ?? fallbackContext
        }`}
      >
        {/* Tagline */}
        {header.tagline && (
          <div
            className="page-template__body__content__heading__tagline"
            role="header.tagline"
          >
            {header.tagline}
          </div>
        )}
        {/* Top of heading */}
        <Inline gap="100" alignment="left" width="100">
          {isMobile && (
            // Visibility of the button controlled in scss if the page body contains a secondary nav or not
            <div className="secondary-nav__button">
              <Icon
                name={
                  isExpanded ? "keyboard_arrow_left" : "keyboard_arrow_right"
                }
                onClick={toggleExpanded}
                className={`secondary-nav-arrow secondary-nav-arrow__icon ${
                  isExpanded
                    ? "secondary-nav-arrow--left"
                    : "secondary-nav-arrow--right"
                }`}
              />
            </div>
          )}
          <Title
            title={header.title}
            hasTitleTooltip={header.hasTitleTooltip}
            subtitle={header.subtitle}
            subtitleActionIcon={header.subtitleActionIcon}
            actions={header.actions}
            icon={header.icon}
            context={header.context ?? fallbackContext}
          />
        </Inline>
      </div>
    </>
  );
};

export default PageHeader;
